@if (!isSimulated) {
    <svg width="40" height="42" viewBox="0 0 40 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20.5 1V6M20.5 32.5V40.5M8 20.5H1M39 20.5H36M33.4142 33.4142L32 32M33.8284 7.33157L31 10.16M6.34315 34.6569L12 29M6.75736 6.91736L11 11.16"
            stroke="#194C4D"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>

    <div class="body-container">
        <h4 class="title">Simulation en cours</h4>

        <div class="message">
            <p>
                L’algorithme analyse actuellement le potentiel thermique et les tracés optimaux pour
                votre territoire. <span>Cette opération peut durer quelques minutes.</span>
            </p>

            <p>
                ⚠️ <span>Information importante :</span> Veuillez ne pas fermer ou actualiser cette
                fenêtre. Une interruption de la navigation annulerait les calculs en cours.
            </p>

            <p>
                <span>À l'issue de la simulation :</span> Un dossier compressé (.zip) sera
                automatiquement téléchargé. Il regroupera, par zone d'opportunité identifiée :
            </p>
            <ul>
                <li>
                    <span>Le rapport d'analyse (PDF) :</span> Synthèse des indicateurs techniques et
                    financiers.
                </li>
                <li>
                    <span>Le tracé cartographique (.gpkg) :</span> Fichier GeoPackage contenant le
                    tracé détaillé du réseau pour vos outils SIG.
                </li>
            </ul>
        </div>
    </div>
} @else {
    <div class="body-container">
        <div class="content">
            <i class="bi bi-check2-circle"></i>

            <div>
                <h4 class="title">Simulation terminée</h4>

                <div class="message">
                    <p>
                        <span>L'analyse de votre territoire est terminée.</span> Le téléchargement
                        de votre dossier de résultats (.zip) a été lancé automatiquement.
                    </p>
                    <span> Que souhaitez-vous faire maintenant ?</span>
                </div>
            </div>
        </div>

        <div class="cta container-fluid">
            <div class="row">
                <div class="col-6">
                    <button type="button" class="secondary" (click)="resetSimulation()">
                        <span class="btn-title">Nouvelle simulation</span>
                        <span class="btn-subtitle"
                            >Réinitialise l'interface pour travailler sur un nouveau projet ou un
                            autre territoire.</span
                        >
                    </button>
                </div>
                <div class="col-6">
                    <button type="button" class="tertiary" (click)="clearXlsxFile()">
                        <span class="btn-title">Ajuster les paramètres</span>
                        <span class="btn-subtitle"
                            >Conserve vos réglages actuels pour effectuer une variante de simulation
                            sur la même zone.</span
                        >
                    </button>
                </div>
            </div>
        </div>
    </div>
}
